import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
// import headerMiddleware from '@js/middleware/headerMiddleware';
// import footerMiddleware from '@js/middleware/footerMiddleware';
import johnsMiddleware from '@js/middleware/johnsMiddleware';
import indexMiddleware from '@js/middleware/indexMiddleware'; // 首頁相關
import memberMiddleware from '@js/middleware/memberMiddleware'; // 會員相關
import cartMiddleware from '@js/middleware/cartMiddleware'; // 购物车相关
import shoppingInfoMiddleware from '@js/middleware/shoppingInfoMiddleware'; // 付款相關
import productMiddleware from '@js/middleware/productMiddleware'; // 商品詳情相關
import orderDetailMiddleware from '@js/middleware/orderDetailMiddleware'; // 訂單細節頁面
import couponMiddleware from '@js/middleware/couponMiddleware'; // 优惠券页面
import orderListMiddleware from '@js/middleware/orderListMiddleware'; // 订单页面
import mmmMiddleware from '@js/middleware/mmmMiddleware'; // MMM相關

import reducers from '@js/reducers';

const enhancer = applyMiddleware(
  // headerMiddleware,
  // footerMiddleware,
  mmmMiddleware,
  johnsMiddleware,
  indexMiddleware, // 首頁
  memberMiddleware, // 會員相關
  shoppingInfoMiddleware, // 付款相關
  cartMiddleware, // 购物车相关
  productMiddleware, // 商品詳情相關
  orderDetailMiddleware, // 訂單細節頁面
  couponMiddleware, // 优惠券页面
  orderListMiddleware, // 订单页面
  thunk,
);

export default createStore(
  reducers,
  composeWithDevTools(
    enhancer,
    // other store enhancers if any
  ),
);
